import { deviceAdminApi } from '@/api';
import { Select } from '@/components/common/Select/Select';
import { handleResponse } from '@/Helper';
import { SelectedDeviceKeys, SelectOptions } from '@/model/CommonModel';
import { Holidays } from '@/model/DeviceAdminModel';
import { Button, Modal, Spin } from 'antd';
import React, { useState } from 'react';
import styles from './holidayMoveModal.module.scss';

type Props = {
	holidays: SelectedDeviceKeys[];
	currentHolidayGroupId: number;
	holidayGroupOptions: SelectOptions<string>[];
	onConfirm: () => void;
	onCancel: () => void;
};

const HolidayMoveModal: React.FC<Props> = ({ holidays, currentHolidayGroupId, holidayGroupOptions, onConfirm, onCancel }) => {
	//#region State Management Variables
	const [loading, setLoading] = useState<boolean>(false);
	const [selectedHolidayGroup, setSelectedHolidayGroup] = useState<string>(holidayGroupOptions[0]?.value);
	//#endregion

	const handleOnSelectionChange = (value: string) => {
		setSelectedHolidayGroup(value);
	};

	const onMoveHolidayRequest = async (holiday: Holidays, newHolidayGroupId: number): Promise<void> => {
		const response = await deviceAdminApi.moveHolidayToHolidayGroup(holiday, currentHolidayGroupId, newHolidayGroupId);
		handleResponse(response);
	};

	const handleOnConfirm = async (): Promise<void> => {
		setLoading(true);
		const selectedHolidays = holidays.map(x => ({ HolidayID: x.Id, Name: x.Name, HolidayGroupId: currentHolidayGroupId } as Holidays));
		const newHolidayGroupId = holidayGroupOptions.find(group => group.value === selectedHolidayGroup).id;
		for (const holiday of selectedHolidays) {
			await onMoveHolidayRequest(holiday, Number(newHolidayGroupId));
		}
		setLoading(false);
		onConfirm();
	};

	const handleOnCancel = () => {
		onCancel();
	};

	const footer = [
		<Button key='cancelMoveHolidaysToHolidayGroup' id='holidayGroupAddCancel' onClick={handleOnCancel}>
			{_('CancelMoveHolidays')}
		</Button>,
		<Button key='confirmMoveHolidaysToHolidayGroup' type='primary' id='holidayGroupMoveHolidayConfirmId' onClick={handleOnConfirm}>
			{_('MoveHolidays')}
		</Button>,
	];

	const content = (
		<div className={styles.holidayGroupMoveActionContainer}>
			<p>{_('SelectHolidayGroupMessage')}</p>
			<br />
			<Select
				key={`holidayGroupSelectionMoveAction`}
				className={styles.holidayGroupMoveActionSelect}
				options={holidayGroupOptions}
				value={selectedHolidayGroup}
				onChange={handleOnSelectionChange}
			/>
		</div>
	);

	return (
		<Modal open={true} footer={footer} onCancel={handleOnCancel}>
			<Spin tip={`${_('Loading')}...`} spinning={loading} size='large'>
				{content}
			</Spin>
		</Modal>
	);
};

export { HolidayMoveModal };
